import * as React from 'react'
import {
  CarrierSectionBottomText,
  CarrierSectionContainer,
  CarrierSectionImage,
  CarrierSectionTopText
} from './CarrierSection.elements'

export type CarrierSectionProps = {
  topText: string;
  bottomText: string;
  imageUrl: string;
  imageHeight: string;
  imageUrlMobile: string;
  imageHeightMobile: string;
  isFeatured: boolean;
  topTextSize?: number;
}

export const CarrierSection: React.FunctionComponent<CarrierSectionProps> = ({ topText, bottomText, imageUrl, imageHeight, imageUrlMobile, imageHeightMobile, isFeatured, topTextSize }) => (
  <CarrierSectionContainer imageUrlMobile={imageUrlMobile}>
    <CarrierSectionTopText topTextSize={topTextSize} isFeatured={isFeatured} bottomText={bottomText} dangerouslySetInnerHTML={{__html: topText}}/>
    <CarrierSectionImage
      imageUrl={imageUrl}
      imageHeight={imageHeight}
      imageHeightMobile={imageHeightMobile}
      imageUrlMobile={imageUrlMobile}
    />
    <CarrierSectionBottomText dangerouslySetInnerHTML={{__html: bottomText}}/>
  </CarrierSectionContainer>
)
